import { useMatches } from '@tanstack/react-router';

export function useRouteId() {
  const matches = useMatches();
  return matches[matches.length - 1]?.routeId;
}
